// extracted by mini-css-extract-plugin
export default {"login-form":"LoginForm_login-form__k9WUQ","sign-in-button":"LoginForm_sign-in-button__s4860","forgot-password-link":"LoginForm_forgot-password-link__LusHm"};